import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation, Form } from "react-router-dom";
import axiosInstance from "../../../../lib/axios";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  RowingRounded,
} from "@mui/icons-material";
import useInitialRender from "../../../../hooks/useInitialRender";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import { getFormMode } from "../../../../lib/helpers";
import CustomAutoCompleteNew from "../../../AutoComplete/CustomAutoCompleteNew";
import CustomAutocomplete from "../../../AutoComplete/AutocompletewithoutIcon";
import { useReactToPrint } from "react-to-print";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";

const FORM_MODE = getFormMode();
const INIT_STATE = {
  TktCategoryId: "",
  PropId: "",
  WardenId: "",
  AltWardenId: "",
  ServiceProvId: "",
};

const columns = [
  { id: "TktCategoryName", label: "CategoryName", minWidth: 100 },
  { id: "PropName", label: "Property", minWidth: 100 },
  { id: "WardenNm", label: "Warden", minWidth: 100 },
  { id: "AltWardenNm", label: "Warden1", minWidth: 100 },
  { id: "ServiceProvName", label: "Provider", minWidth: 100 },
];

const WardenAllocation = () => {
  const navigate = useNavigate();
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [categories, setcategories] = useState([]);
  const location = useLocation();
  const [currentPropId, setCurrentPropId] = useState(() => {
    if (location.state && location.state?.PropId) {
      return location.state && location.state?.PropId;
    }
  });
  const [form, setForm] = useState({ ...INIT_STATE, PropId: location?.state?.PropId || "" });

  const [mode, setMode] = useState(() =>
    currentPropId ? FORM_MODE.read : FORM_MODE.add
  );
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const [Status, setStatus] = useState("1");
  const [properties, setProperties] = useState([]);
  const [wardens, setWardens] = useState([]);
  const [altwardens, setAltWardens] = useState([]);
  const [provider, setProvider] = useState([]);
  const [addedData, setAddedData] = useState([]);
  const [editingEntryId, setEditingEntryId] = useState(null);
  const [hasUserAddedData, setHasUserAddedData] = useState(false);
  const [editRowId, setEditRowId] = useState(null);
  const [entryToDelete, setEntryToDelete] = useState(null);
  const [isRefCategory, setIsRefCategory] = useState(false);
  const [isRefProvider, setIsRefProvider] = useState(false);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const RequiredLabel = ({ label }) => (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '2px' }}>
      <span style={{ color: 'red', fontSize: '1rem' }}>*</span>
      <span style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
    </div>
  );

  const openCategory = () => {
    window.open("/ticket-category")
  }

  const openServiceProvider = () => {
    window.open("/");
  }

  const handleRefreshProvider = async () => {
    setIsRefProvider(true);
    try {
      if (form.TktCategoryId) {
        await fetchProviderDrp(form.TktCategoryId);
      }
    } catch (error) {
      console.error("Error fetching service providers. Please try again.", error);
    } finally {
      setIsRefProvider(false);
    }
  };

  const handleRefreshCategory = async () => {
    setIsRefCategory(true);
    try {
      const response = await axiosInstance.get(
        `TktCategory/getTktCategorydrp`
      );
      const {
        data: { Status, Data },
      } = response;
      if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
        setcategories(Data);
        if (Data.length > 0) {
          setForm((prevData) => ({
            ...prevData,
            TktCategoryId: Data[0]?.TktCategoryId || "",
          }));
        }
      } else {
        setcategories([]);
        setForm((prevData) => ({
          ...prevData,
          TktCategoryId: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching CategoryName. Please try again.", error);
    }
    finally {
      setTimeout(() => {
        setIsRefCategory(false);
      }, 300);
    }
  }

  useEffect(() => {
    const getRow = async () => {
      const params = {
        PropId: 1,
        WardenId: 1,
        ServiceProvId: 1,
        TktCategoryId: 1,
        Flag: "Dash",
      };

      try {
        const res = await axiosInstance.post('TktCategory/GetMstPropWiseServProDashBoard', { params });

        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  useEffect(() => {
    const fetchPropertyDrp = async () => {
      try {
        const response = await axiosInstance.post(
          "PropertyMst/GetPropertyMstUserwisedrp",
          {
            Flag: "",
            UserId: UserId,
          }
        );
        const {
          data: { Status, Data },
        } = response;
        if (Status === 0 && Array.isArray(Data)) {
          setProperties(Data);
          if (mode === FORM_MODE.add || mode === FORM_MODE.edit) {
            if (currentPropId) {
              setForm((prevData) => ({
                ...prevData,
                PropId: currentPropId,
              }));
            } else if (Data.length > 0) {
              setForm((prevData) => ({
                ...prevData,
                PropId: Data[0].Id,
              }));
            }
          }
        }
      } catch (error) {
        return error;
      }
    };
    fetchPropertyDrp();
  }, []);

  useEffect(() => {
    const fetchCategoryName = async () => {
      try {
        const response = await axiosInstance.get(
          `TktCategory/getTktCategorydrp`
        );
        const {
          data: { Status, Data },
        } = response;
        if (Status === 0 && Array.isArray(Data) && Data.length > 0) {
          setcategories(Data);
          if (Data.length > 0) {
            setForm((prevData) => ({
              ...prevData,
              TktCategoryId: Data[0]?.TktCategoryId || "",
            }));
          }
        } else {
          setcategories([]);
          setForm((prevData) => ({
            ...prevData,
            TktCategoryId: "",
          }));
        }
      } catch (error) {
        console.error("Error fetching CategoryName. Please try again.", {
          autoClose: 1000,
        });
      }
    };
    fetchCategoryName();
  }, []);

  useEffect(() => {
    if (form.PropId) {
      const fetchWardenDrp = async () => {
        try {
          const response = await axiosInstance.post(
            "TrnTicketing/getPropertyWisedrp",
            {
              PropId: form.PropId,
              Flag: "Wr",
            }
          );
          const {
            data: { Status, Data },
          } = response;
          if (Status === 0 && Array.isArray(Data)) {
          
            setWardens(Data);
            if (Data.length > 0) {
              setForm((prevData) => ({
                ...prevData,
                WardenId: Data[0]?.WardenId || "",
              }));
            }
          } else {
            setWardens([]);
            setForm((prevData) => ({
              ...prevData,
              WardenId: "",
            }));
          }
        } catch (error) {
          return error;
        }
      };
      fetchWardenDrp();
    }
  }, [form.PropId]);

  useEffect(() => {
    if (form.PropId) {
      const fetchWarden1Drp = async () => {
        try {
          const response = await axiosInstance.post(
            "TrnTicketing/getPropertyWisedrp",
            {
              PropId: form.PropId,
              Flag: "Wr",
            }
          );
          const {
            data: { Status, Data },
          } = response;
          if (Status === 0 && Array.isArray(Data)) {
          
            setAltWardens(Data);
            if (Data.length > 0) {
              setForm((prevData) => ({
                ...prevData,
                AltWardenId: Data[0]?.AltWardenId || "",
              }));
            }
          } else {
            setAltWardens([]);
            setForm((prevData) => ({
              ...prevData,
              AltWardenId: "",
            }));
          }
        } catch (error) {
          return error;
        }
      };
      fetchWarden1Drp();
    }
  }, [form.PropId]);

  const fetchProviderDrp = async (tktCategoryId) => {
    try {
      const response = await axiosInstance.post(
        "TktCategory/GetMstPropWiseServProDashBoard",
        {
          PropId: 1,
          WardenId: 1,
          ServiceProvId: 1,
          TktCategoryId: tktCategoryId,
          Flag: "Cat",
        }
      );
      const {
        data: { Status, Data },
      } = response;
      if (Status === 0 && Array.isArray(Data)) {
       
        setProvider(Data);
        setForm({
          ...form,
          ServiceProvId: Data[0]?.ServiceProvId,
        });
      } else {
        setProvider([]);
        setForm((prevData) => ({
          ...prevData,
          ServiceProvId: "",
        }));
      }
    } catch (error) {
      return console.log(error);
    }
  };

  useEffect(() => {
    const fetchDrp = async () => {
      try {
        if (form.TktCategoryId) {
          await fetchProviderDrp(form.TktCategoryId);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchDrp();
  }, [form.TktCategoryId]);


  const handleInputChange = (event) => {
    const { name, value } = event.target;
   
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
   
    fetchCategoryData(form.PropId);
  }, [form.PropId]);

  const fetchCategoryData = async (propId) => {
    try {
      const response = await axiosInstance.post(
        `TktCategory/GetMstPropWiseServProDashBoard`,
        {
          PropId: propId,
          WardenId: 1,
          ServiceProvId: 1,
          TktCategoryId: 1,
          Flag: "DashR",
        }
      );
      const {
        data: { Status, Message, Data, responseStatusCode },
      } = response;

      if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
        const data = Data[0];
        setRows(Data);
        if (!form.PropId) {
          setForm((prevData) => ({
            ...prevData,
            PropId: data.PropId,
          }));
        }
      } else {
        console.error("Failed to fetch warden allocation data");
        setRows([]);
      }
    } catch (error) {
      console.error("Error fetching warden master data:", error);
    }
  };

  const handleDelete = () => {
    setOpenConfirmDialog(true);
  };
  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    const propIdToUse = form.PropId || currentPropId;

    const payload = {
      PropId: propIdToUse,
      TktCategoryId: 1,
    };

    if (!payload.PropId) {
    
      toast.error("PropId is missing or invalid");
      return;
    }
    try {
      const response = await axiosInstance.post(
        "TktCategory/DeleteMstCatWiseProp",
        payload
      );
      const {
        data: { Status, Message },
      } = response;
      if (Status === 0 && Message) {
        toast.success(Message);
        await fetchCategoryData(propIdToUse);
      }
    } catch (error) {
      console.error("Error deleting entry:", error);
    }
  };

  const handlePrevious = () => { };
  const handleNext = () => { };

  const handleEdit = () => {
    setMode(FORM_MODE.edit);
  };
  useEffect(() => {
    console.log("Form state updatednew:", form);
  }, [form]);

  const handleAdd = () => {
    setMode(FORM_MODE.add);
    setForm((prevData) => {
      const newState = {
        ...INIT_STATE,
        PropId: form.PropId,
      };
     
      return newState;
    });
  };

  const handleCancel = async () => {
    setMode(FORM_MODE.read);
  };

  const handleExit = () => {
    navigate("/warden-allocation-table");
  };

  const handleUpdateIndividual = (entry) => {

    setForm({
      TktCategoryId: entry.TktCategoryId,
      PropId: entry.PropId,
      WardenId: entry.WardenId,
      AltWardenId: entry.AltWardenId,
      ServiceProvId: entry.ServiceProvId,
    });
   
    setEditRowId(entry.Id);
    setMode(FORM_MODE.edit);
  };

  const handleAddServiceProvider = async () => {
    const isWardenSelected = form.WardenId || form.AltWardenId;
    if (!isWardenSelected) {
      toast.error("Please select at least one warden.", { autoClose: 1000 });
      return;
    }

    if (
      !form.TktCategoryId ||
      !form.PropId ||
      !form.ServiceProvId
    ) {
      toast.error("Please choose values from all fields.", { autoClose: 1000 });
      return;
    }

    const isValidServiceProvId = provider.some(
      (prov) => prov.ServiceProvId === form.ServiceProvId
    );
    if (!isValidServiceProvId) {
      toast.error("Selected Service Provider is invalid.", { autoClose: 1000 });
      return;
    }

    const isDuplicateEntry = rows.some(
      (entry) =>
        entry.PropId === form.PropId &&
        entry.TktCategoryId === form.TktCategoryId &&
        (editRowId ? entry.Id !== editRowId : true)
    );

    if (isDuplicateEntry) {
      toast.error("This category has already been added for this property.", {
        autoClose: 2000,
      });
      return;
    }

    const newEntry = {
      TktCategoryId: form.TktCategoryId,
      PropId: form.PropId,
      WardenId: form.WardenId,
      AltWardenId: form.AltWardenId,
      ServiceProvId: form.ServiceProvId,
    };

    const displayEntry = {
      Id: editRowId || Date.now(),
      PropName: properties.find((prop) => prop.Id === form.PropId)?.Name,
      TktCategoryName: categories.find((cat) => cat.Id === form.TktCategoryId)
        ?.Name,
      WardenNm: form.WardenId
        ? wardens.find((warden) => warden.Id === form.WardenId)?.Name
        : "",
      AltWardenNm: form.AltWardenId
        ? altwardens.find((warden) => warden.Id === form.AltWardenId)?.Name
        : "",
      ServiceProvName:
        provider.find((prov) => prov.ServiceProvId === form.ServiceProvId)
          ?.ServiceProvName ||
        rows.find((row) => row.Id === editRowId)?.ServiceProvName,
    };

    if (editRowId) {
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.Id === editRowId ? { ...displayEntry, ...newEntry } : row
        )
      );
      setEditRowId(null);
    } else {
      setRows((prevRows) => [...prevRows, { ...displayEntry, ...newEntry }]);
    }

    setAddedData((prevData) => {
      if (editRowId) {
        return prevData.map((data) =>
          data.Id === editRowId ? newEntry : data
        );
      }
      return [...prevData, newEntry];
    });

    setForm((prevData) => ({
      ...prevData,
      TktCategoryId: "",
      PropId: form.PropId,
      WardenId: "",
      AltWardenId: "",
      ServiceProvId: "",
    }));
  };

  const getProviderValue = () => {
    const found = provider?.find((prov) => prov.ServiceProvId === form.ServiceProvId);
 
    if (!found) return "";
    return {
      Id: found.ServiceProvId,
      Name: found.ServiceProvName
    }
  }

  const handleSubmit = async () => {
    const isFormPartiallyFilled =
      // form.PropId ||
      form.TktCategoryId || form.WardenId || form.AltWardenId || form.ServiceProvId;

    const isFormAlreadyAdded = rows.some(
      (row) =>
        // row.PropId === form.PropId &&
        row.TktCategoryId === form.TktCategoryId &&
        row.WardenId === form.WardenId &&
        row.AltWardenId === form.AltWardenId &&
        row.ServiceProvId === form.ServiceProvId
    );

    if (isFormPartiallyFilled && !isFormAlreadyAdded) {
      toast.error("Please click 'Add' before submitting.", {
        autoClose: 1000,
      });
      return;
    }
    if (rows.length === 0) {
      toast.error("No data for Submit.", {
        autoClose: 1000,
      });
      return;
    }
     if (addedData.length === 0) {
    toast.error("No new data has been added or updated.", {
      autoClose: 1000,
    });
    return;
  }
    
    const result = {
      PropWiseServProConfig: rows.map((row) => ({
        PropId: row.PropId,
        WardenId: row.WardenId || 1,
        TktCategoryId: row.TktCategoryId,
        AltWardenId: row.AltWardenId || 1,
        ServiceProvId: row.ServiceProvId,
      })),
    };

    let jsonData = JSON.stringify(result);
    jsonData = jsonData.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    jsonData = '"' + jsonData + '"';

    try {
      const response = await axiosInstance.post(
        "TktCategory/ManageMstCatWiseProp",
        jsonData
      );

      const {
        data: { Status, Message },
      } = response;

      if (Status === 0) {
        toast.success(Message, { autoClose: 1000 });
        setMode(FORM_MODE.read);
        setIsFormDisabled(true);
        setForm((prevData) => ({
          ...prevData,
          TktCategoryId: "",
          WardenId: "",
          AltWardenId: "",
          ServiceProvId: "",
        }));
        setEditRowId(null);
      } else {
        console.error(Message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error adding service provider:", error);
    }
  };

  const handleDeleteIndividual = async (entry) => {
    try {
      // Perform API call to delete the specific row
      const response = await axiosInstance.post(
        "TktCategory/DeleteMstCatWiseProp",
        {
          PropId: entry.PropId,
          TktCategoryId: entry.TktCategoryId,
        }
      );
      const {
        data: { Status, Message },
      } = response;
      if (Status === 0 && Message) {
        toast.success(Message);
        // Update rows state to remove the specific row
        setRows((prevRows) =>
          prevRows.filter((row) => row.Id !== entry.Id)
        );
        // Update addedData state to remove the specific entry
        setAddedData((prevData) =>
          prevData.filter(
            (item) =>
              item.PropId !== entry.PropId ||
              item.TktCategoryId !== entry.TktCategoryId
          )
        );
      }
    } catch (error) {
      console.error("Error deleting entry:", error);
    }
  };

  // useEffect(() => {
  //   console.log("Current rows:", rows);
  // }, [rows]);

  return (
    <>
      <ToastContainer />
      <Box className="form-container"
        sx={{
          width: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          maxWidth: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          overflowX: "hidden",
          overflowY: { xs: "auto", sm: "hidden", md: "hidden" },
        }}
      >

        <Grid container spacing={2}
          sx={{
            width: { xs: "93%", sm: "80%", md: "80%" },
            height: 'auto',
            margin: 'auto',
            marginTop: { xs: "60px", sm: 0, md: 'auto' },
            marginBottom: { xs: "110px", sm: 0, md: 'auto' },
            borderRadius: '8px',
            padding: { xs: '0px 5px 5px 5px', sm: '0px 20px 20px 20px' },  // Responsive padding: full left/right on mobile, as per original on larger screens
            backgroundColor: '#fff',
          }}>

          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              marginInline: "0px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid>
              <Typography variant="h5">Warden/Vendor Allocation</Typography>
            </Grid>
            <Grid>
              <CrudButtons
                moduleName="Ticket SubCategory"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onView={handlePrint}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={mode === FORM_MODE.read}
              />
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            className="form_field"
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={2}
              justifyContent="center"
              sx={{ maxWidth: "800px", width: "100%" }}
            >
              <Grid item xs={12} md={12}>
                <CustomAutocomplete
                  id="propId-select"
                  name="PropId"
                  options={properties}
                  value={properties.find((property) => property.Id === form.PropId) || null}
                  onChange={handleInputChange}
                  label={
                    <span>
                      Select Property <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  disabled={mode === FORM_MODE.read}
                />
              </Grid>
              <Grid item xs={12} md={2.6}>
                <CustomAutoCompleteNew
                  id="TktCategoryName-select"
                  name="TktCategoryId"
                  options={categories}
                  value={categories.find((category) => category.Id === form.TktCategoryId) || ''}
                  onChange={handleInputChange}
                  label={<RequiredLabel label="Category" />}
                  disabled={mode === FORM_MODE.read}
                  onAddClick={openCategory}
                  onRefreshClick={handleRefreshCategory}
                  isRefreshing={isRefCategory}
                  sx={{ '& .MuiFormLabel-root': { maxWidth: '90%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', top: '-2px', transform: 'translate(14px, -6px) scale(0.75)' } }}
                />
              </Grid>
              <Grid item xs={12} md={2.6}>
                <CustomAutocomplete
                  id="WardenId-select"
                  name="WardenId"
                  options={wardens}
                  onChange={handleInputChange}
                  disabled={mode === FORM_MODE.read}
                  value={wardens.find((warden) => warden.Id === parseInt(form.WardenId)) || ''}
                  label={
                    <span>
                      Select Warden <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                />
              </Grid>
              <Grid item xs={12} md={2.6}>
                <CustomAutocomplete
                  id="AltWardenId-select"
                  name="AltWardenId"
                  options={altwardens}
                  value={altwardens.find((altwarden) => altwarden.Id === parseInt(form.AltWardenId)) || ''}
                  onChange={handleInputChange}
                  label={
                    <span>
                      Select Warden1 <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  disabled={mode === FORM_MODE.read}
                />
              </Grid>
              <Grid item xs={12} md={2.6}>
                <CustomAutoCompleteNew
                  id="ServiceProvId-select"
                  name="ServiceProvId"
                  options={provider?.map(p => ({ Id: p.ServiceProvId, Name: p.ServiceProvName }))}
                  value={getProviderValue()}
                  onChange={handleInputChange}
                  label={<RequiredLabel label="ServProvider" />}
                  disabled={mode === FORM_MODE.read}
                  onAddClick={openServiceProvider}
                  onRefreshClick={handleRefreshProvider}
                  isRefreshing={isRefProvider}
                  sx={{ '& .MuiFormLabel-root': { maxWidth: '90%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', top: '-2px', transform: 'translate(14px, -6px) scale(0.75)' } }}
                />
              </Grid>
              <Grid item xs={12} md={1.6} sx={{ marginBottom: "0px" }}>
                <Button
                  variant="contained"
                  sx={{
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                    borderRadius: "20px",
                    padding: "5px 10px",
                    "&:hover": {
                      background: "linear-gradient(290deg, #a8c3e0, #d0e7f5)",
                    },
                  }}
                  onClick={handleAddServiceProvider}
                >
                  {editRowId ? "Update" : "Add"}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <TableContainer
                  component={Paper}
                  sx={{
                    maxHeight: { xs: '300px', sm: '200px', md: '200px' },
                    overflowY: "auto",
                    boxShadow: 3,
                    borderRadius: 2,
                  }}
                >
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#e8f5e9",
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "1px solid #c8e6c9",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Property
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#e8f5e9",
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "1px solid #c8e6c9",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Category
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#e8f5e9",
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "1px solid #c8e6c9",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Warden
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#e8f5e9",
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "1px solid #c8e6c9",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Warden1
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#e8f5e9",
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "1px solid #c8e6c9",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Service Provider
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#e8f5e9",
                            textAlign: "left",
                            padding: "12px",
                            borderBottom: "1px solid #c8e6c9",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.length === 0 ? (
                        <TableRow>
                          <TableCell
                            colSpan={6}
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Typography
                                variant="h6"
                                style={{ color: "#555" }}
                              >
                              No Data Found...
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ) : (
                        Array.isArray(rows) &&
                        rows.map((row, index) => (
                          <TableRow
                            key={row.Id}
                            sx={{
                              "&:hover": { backgroundColor: "#f1f8e9" },
                              transition: "background-color 0.3s ease",
                              backgroundColor: row.Id === editRowId ? "#e3f2fd" : "inherit",
                            }}
                          >
                            <TableCell
                              sx={{
                                padding: "5px",
                                borderBottom: "1px solid #ddd",
                                textAlign: "left",
                                color: "#333",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                              }}
                            >
                              {row.PropName}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "5px",
                                borderBottom: "1px solid #ddd",
                                textAlign: "left",
                                color: "#333",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                              }}
                            >
                              {row.TktCategoryName}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "5px",
                                borderBottom: "1px solid #ddd",
                                textAlign: "left",
                                color: "#333",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                              }}
                            >
                              {row.WardenNm}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "5px",
                                borderBottom: "1px solid #ddd",
                                textAlign: "left",
                                color: "#333",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                              }}
                            >
                              {row.AltWardenNm}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "5px",
                                borderBottom: "1px solid #ddd",
                                textAlign: "left",
                                color: "#333",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                              }}
                            >
                              {row.ServiceProvName}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "5px",
                                borderBottom: "1px solid #ddd",
                                textAlign: "left",
                                color: "#333",
                                display: "flex",
                                justifyContent: "space-around",
                                whiteSpace: { xs: "nowrap", sm: "normal" },
                              }}
                            >
                              <EditIcon
                                sx={{
                                  margin: "0px 0px 0px 0px",
                                  color:
                                    mode === FORM_MODE.read
                                      ? "gray"
                                      : "inherit",
                                  cursor:
                                    mode === FORM_MODE.read
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                onClick={
                                  mode !== FORM_MODE.read
                                    ? () => handleUpdateIndividual(row)
                                    : undefined
                                }
                              />
                              <DeleteIcon
                                sx={{
                                  margin: "0px 0px 0px 0px",
                                  color:
                                    mode === FORM_MODE.read
                                      ? "gray"
                                      : "inherit",
                                  cursor:
                                    mode === FORM_MODE.read
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                onClick={
                                  mode !== FORM_MODE.read
                                    ? () => handleDeleteIndividual(row)
                                    : undefined
                                }
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            className="form_button"
            style={{
              marginTop: "10px",
              marginBottom: { xs: '10px', sm: '0px', md: "0px" }
            }}
          >
            {mode === FORM_MODE.read && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #635bff, #635bff)",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #635bff, #635bff)",
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box >

      <div style={{ display: 'none' }}>
        {rows.length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="Service Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: '#f5f5f5' }}
          />
        )}
      </div>
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default WardenAllocation;